// extracted by mini-css-extract-plugin
module.exports = {"DynamicToast":"DynamicToast_DynamicToast__QBnvP","FontMedium":"DynamicToast_FontMedium__1Awrh","FontLarge":"DynamicToast_FontLarge__2XIJ7"};